// extracted by mini-css-extract-plugin
module.exports = {"readOnly":"DraggableMarker_readOnly__1O4Tk"};